/**
 * Icon Buttons Component
 * Search, Chat, and notification icon buttons with shadcn Tooltip
 * Desktop only (hidden on mobile < 768px)
 */

import { useNavigate } from "react-router-dom"
import { ChatBubbleIcon, SearchIcon } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { TooltipProvider } from "@/components/ui/tooltip"
import { UnreadBadge } from "@/features/chats/components/chat/UnreadBadge"
import { useChatUnreadCount } from "@/features/chats/hooks/useChatUnreadCount"
import { NotificationsSheet } from "@/features/notifications/components/NotificationsSheet"

interface IconButtonsProps {
  onSearchOpen: () => void
}

export function IconButtons({ onSearchOpen }: IconButtonsProps) {
  const navigate = useNavigate()
  const { data: unreadCount } = useChatUnreadCount()

  return (
    <TooltipProvider>
      <div className="hidden lg:flex items-center gap-0">
        {/* Chat Button */}
        <Button
          variant="ghost"
          size="icon"
          aria-label="Chat"
          className="relative rounded-lg"
          onClick={() => navigate("/chats")}
        >
          <ChatBubbleIcon className="!w-[25px] !h-[25px]" />
          {(unreadCount ?? 0) > 0 && (
            <UnreadBadge count={unreadCount ?? 0} className="absolute -top-1 right-0" />
          )}
        </Button>

        {/* Notifications Sheet - uses internal state (uncontrolled mode) */}
        <NotificationsSheet />

        {/* Search Button */}
        <Button
          variant="ghost"
          size="icon"
          aria-label="Search"
          className="rounded-lg"
          onClick={onSearchOpen}
        >
          <SearchIcon className="!w-[20px] !h-[20px] text-charcoal" />
        </Button>
      </div>
    </TooltipProvider>
  )
}
